import { useEffect } from 'react'
import '../DocumentPage.css'

const Installation = () => {
  useEffect(() => {
    const headings = document.querySelectorAll('.doc-content h2, .doc-content h3')
    headings.forEach((heading) => {
      if (!heading.id) {
        heading.id = heading.textContent.toLowerCase().replace(/\s+/g, '-').replace(/[^\w-]/g, '')
      }
    })
  }, [])

  return (
    <div className="doc-page">
      <div className="doc-content">
        <h1>Installation</h1>
        <p className="lead">
          Follow these steps to install the Variable Modding System plugin in your Unreal Engine project.
        </p>

        <h2>Prerequisites</h2>
        <ul>
          <li>Unreal Engine 5.0 or higher</li>
          <li>Basic knowledge of Unreal Engine plugins</li>
          <li>Access to the Fab marketplace</li>
        </ul>

        <h2>Installation Steps</h2>

        <h3>Step 1: Purchase and Download</h3>
        <p>
          Purchase the Variable Modding System from the{' '}
          <a href="https://www.fab.com/your-plugin" target="_blank" rel="noopener noreferrer">
            Fab marketplace
          </a>{' '}
          and download the plugin files.
        </p>

        <h3>Step 2: Install to Engine</h3>
        <p>Install the plugin to your Unreal Engine installation or project:</p>
        <ol>
          <li>Open the Epic Games Launcher</li>
          <li>Go to your Library</li>
          <li>Find Variable Modding System in your Vault</li>
          <li>Click "Install to Engine" and select your engine version</li>
        </ol>

        <h3>Step 3: Enable in Project</h3>
        <p>Enable the plugin in your Unreal Engine project:</p>
        <ol>
          <li>Open your project in Unreal Engine</li>
          <li>Go to <strong>Edit → Plugins</strong></li>
          <li>Search for "Variable Modding System"</li>
          <li>Check the box to enable it</li>
          <li>Restart the editor when prompted</li>
        </ol>

        <h2>Verification</h2>
        <p>To verify the installation was successful:</p>
        <ol>
          <li>Check that the plugin appears in your Content Browser under "Plugins"</li>
          <li>Look for the Variable Modding System tools in the editor toolbar</li>
          <li>Try creating a new CSV configuration asset to confirm functionality</li>
        </ol>

        <h2>Next Steps</h2>
        <p>Now that you've installed the plugin, proceed to:</p>
        <ul>
          <li><a href="#/getting-started/initial-configuration">Initial Configuration</a></li>
          <li><a href="#/getting-started/in-editor-testing">In-Editor Testing</a></li>
        </ul>
      </div>
    </div>
  )
}

export default Installation
